export enum URLS {
  ROOT_PATH = '/',
  LOGIN_PATH = '/auth/login',
  REGISTER_PATH = '/auth/register',
  FORGOT_PASSWORD_PATH = '/auth/forgot-password',
}
